import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import twoimg1 from "../IMAGES-ADHIBA/ABOUTPAGE/Group 28.png"
import testiimg1 from "../IMAGES-ADHIBA/ABOUTPAGE/image (59).png"
import { faAngleRight, faCircleUser } from "@fortawesome/free-solid-svg-icons";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';
import './testi.css'

export default function Testimonial() {
    return (
        <>
            {/* TESTIMONIAL */}
            <section className="Testimonial-about-adhiba">
                <div className="half-color-box">
                    <div className="container spacer por">
                        <div className="Testimonial-heading-div">
                            <h3 className="pt-5">Testimonials</h3>
                            <p>
                                Our testimonials reflect our commitment to excellence, showcasing how our <br />innovative solutions and exceptional service have exceeded customer expectations.
                            </p>
                        </div>
                        <div className="test-arrowbox">
                            <div className="swiper-button-prev-test">
                                <svg fill="#393185" height="34" className="arrow left">
                                    <use xlinkHref="#arrow" />
                                </svg>
                            </div>
                            <div className="swiper-button-next-test">
                                <div className="arrow-right">
                                    <svg fill="#393185" height="60" width="60" className="arrow">
                                        <use xlinkHref="#arrow" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <Swiper
                            className="swiper-container swiper-testimonial"
                            slidesPerView={3}
                            spaceBetween={30}
                            navigation={{
                                nextEl: '.swiper-button-next-test',
                                prevEl: '.swiper-button-prev-test',
                            }}
                            breakpoints={{
                                // When window width is >= 1200px
                                1200: {
                                    slidesPerView: 3,
                                    spaceBetween: 30,
                                },
                                // When window width is >= 768px
                                768: {
                                    slidesPerView: 2,
                                    spaceBetween: 20,
                                },
                                // When window width is >= 480px
                                480: {
                                    slidesPerView: 1,
                                    spaceBetween: 10,
                                },
                                // Default for smaller screens
                                0: {
                                    slidesPerView: 1,
                                    spaceBetween: 10,
                                },
                            }}
                        >
                            {/* Slide 1 */}
                            <SwiperSlide>
                                <div className="review-box">
                                    <div className="media d-flex">
                                        {/* <img
                                            className="mr-3"
                                            src="https://picsum.photos/50/50?random=1"
                                            alt="Generic placeholder"
                                        /> */}
                                        <FontAwesomeIcon icon={faCircleUser} className="testmonial-icon-adhiba" />
                                        <div className="media-body">
                                            <h5>vasudevan p.k</h5>
                                            <p className="user-post">Electrical contractor</p>
                                        </div>
                                    </div>
                                    <p className="read">
                                        "The most recommended water saver.The device has been installed in my house a year back and it's doing a great job."
                                    </p>
                                    {/* <img className="quote" src="img/icons/quote.svg" alt="Quote icon" /> */}
                                </div>
                            </SwiperSlide>

                            {/* Slide 2 */}
                            <SwiperSlide>
                                <div className="review-box">
                                    <div className="media d-flex">
                                        {/* <img
                                            className="mr-3"
                                            src="https://picsum.photos/50/50?random=2"
                                            alt="Generic placeholder"
                                        /> */}
                                        <FontAwesomeIcon icon={faCircleUser} className="testmonial-icon-adhiba" />
                                        <div className="media-body">
                                            <h5>Boopathi.S</h5>
                                            <p className="user-post">Farmer</p>
                                        </div>
                                    </div>
                                    <p className="read">
                                        "Really a good product &  must recommended one.i had Installed this device 6months back & working with perfect conditions."
                                    </p>
                                    {/* <img className="quote" src="img/icons/quote.svg" alt="Quote icon" /> */}
                                </div>
                            </SwiperSlide>

                            {/* Slide 3 */}
                            <SwiperSlide>
                                <div className="review-box">
                                    <div className="media d-flex">
                                        {/* <img
                                            className="mr-3"
                                            src="https://picsum.photos/50/50?random=3"
                                            alt="Generic placeholder"
                                        /> */}
                                        <FontAwesomeIcon icon={faCircleUser} className="testmonial-icon-adhiba" />
                                        <div className="media-body">
                                            <h5>Ishwarya RajendraKumar k</h5>
                                            <p className="user-post">Home Maker</p>
                                        </div>
                                    </div>
                                    <p className="read">
                                        "The most recommended water saver.The device has been installed in my house a year back and it's doing a great job."
                                    </p>
                                    {/* <img className="quote" src="img/icons/quote.svg" alt="Quote icon" /> */}
                                </div>
                            </SwiperSlide>

                            {/* Slide 4 */}
                            <SwiperSlide>
                                <div className="review-box">
                                    <div className="media d-flex">
                                        {/* <img
                                            className="mr-3"
                                            src="https://picsum.photos/50/50?random=3"
                                            alt="Generic placeholder"
                                        /> */}
                                        <FontAwesomeIcon icon={faCircleUser} className="testmonial-icon-adhiba" />
                                        <div className="media-body">
                                            <h5>Hari Prasath.S</h5>
                                            <p className="user-post">Software Developer</p>
                                        </div>
                                    </div>
                                    <p className="read">
                                        "I've a excellent experience with Adhiba Technologies and their innovative smart class sensors !!!"
                                    </p>
                                    {/* <img className="quote" src="img/icons/quote.svg" alt="Quote icon" /> */}
                                </div>
                            </SwiperSlide>

                            {/* Slide 5 */}
                            <SwiperSlide>
                                <div className="review-box">
                                    <div className="media d-flex">
                                        {/* <img
                                            className="mr-3"
                                            src="https://picsum.photos/50/50?random=3"
                                            alt="Generic placeholder"
                                        /> */}
                                        <FontAwesomeIcon icon={faCircleUser} className="testmonial-icon-adhiba" />
                                        <div className="media-body">
                                            <h5>Selva Kumar.P</h5>
                                            <p className="user-post">Civil Engineer</p>
                                        </div>
                                    </div>
                                    <p className="read">
                                        "Wireless Tank Manager - Adhiba Labs Private Limited I have been using it for the last 6 months and it's very nice "
                                    </p>
                                    {/* <img className="quote" src="img/icons/quote.svg" alt="Quote icon" /> */}
                                </div>
                            </SwiperSlide>

                         
                        </Swiper>

                        {/* <div className="swiper-pagination"></div> */}
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" style={{ display: 'none' }}>
                        <symbol id="arrow" viewBox="0 0 400.004 400.004">
                            <g>
                                <path d="M382.688,182.686H59.116l77.209-77.214c6.764-6.76,6.764-17.726,0-24.485c-6.764-6.764-17.73-6.764-24.484,0L5.073,187.757 c-6.764,6.76-6.764,17.727,0,24.485l106.768,106.775c3.381,3.383,7.812,5.072,12.242,5.072c4.43,0,8.861-1.689,12.242-5.072 c6.764-6.76,6.764-17.726,0-24.484l-77.209-77.218h323.572c9.562,0,17.316-7.753,17.316-17.315 C400.004,190.438,392.251,182.686,382.688,182.686z" />
                            </g>
                        </symbol>
                    </svg>

                </div>
                <img src={testiimg1} className="img-fluid w-100 test-img-down-adhiba" style={{ borderRadius: "0" }} />
            </section>
        </>
    )
}